import getWebShellClientLocale from '../state/redux-replacement/get-webshellclient-locale';
import getHostname from './get-hostname';

const deriveUrlWithFragment = pathParameter => {
  const locale = getWebShellClientLocale();
  const urlLocale = locale?.cloudUrlFragment;
  const urlLocaleFragment = urlLocale ? `/${urlLocale}/` : '/';
  const hostname = getHostname();
  return `https://${hostname}${urlLocaleFragment}${pathParameter}`;
};

export default deriveUrlWithFragment;
